import Base from './base'
import ParticipantGroups from './participant_groups'
import ParticipantGroup from './participant_group'
import Person from './mixins/_person'
import { format } from 'date-fns'

export default class Participant extends Base {
  get defaults () {
    return {
      checked: false,
      groups: new ParticipantGroups([])
    }
  }

  // Eek! We need this as /api/participants returns *memberships* so `this.get('id')`
  // would be the membershipId, not the participantId as this can also be instantiated
  // elsewhere, with 'real' participants we need to handle both cases - defaulting to
  // the voter_id where present
  get participantId () {
    return this.has('voter_id') ? this.get('voter_id') : this.get('id')
  }

  initialize () {
    super.initialize(...arguments)

    this.include(Person)
  }

  urlRoot () {
    return '/api/participants'
  }

  groupIds () {
    const groups = this.get('groups').pluck('id')

    if (!groups.length) { groups.push(0) }

    return groups
  }

  /*
   * accepts a ParticipantGroup
   * or an id and determines if the participant
   * is assigned to the corresponding group
   */
  assignedTo (group) {
    return this.get('groups').get(group)
  }

  formattedRegisteredOn () {
    return format(new Date(this.get('created_at')), 'MM/dd/yyyy')
  }

  byLastName () {
    return this.fullName({
      reverse: true,
      delimeter: ', '
    })
  }

  parse (attrs) {
    /*
     * TODO come up with a convention for
     * parsing out associations from our api
     */
    attrs.groups = new ParticipantGroups(attrs.groups)

    return super.parse(...arguments)
  }

  assignToGroup (groupId) {
    const group = new ParticipantGroup({ id: groupId })

    this.get('groups').add(group)

    return this.sync('create', this, {
      processData: true,
      data: {
        participant_group_id: groupId,
        participant_id: this.participantId
      },
      url: '/api/participant_participant_groups'
    })
  }

  removeFromGroup (groupId) {
    const group = new ParticipantGroup({ id: groupId })

    this.get('groups').remove(group)

    return this.sync('delete', this, {
      processData: true,
      data: {
        participant_group_id: groupId,
        participant_id: this.participantId
      },
      url: '/api/participant_participant_groups/-1'
    })
  }
}
